import React, { useEffect, useRef, useState } from 'react';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import useFlipMenu from '../hooks/useFlipMenu';

// §1.9 — "Archive old suggestions…" — a proper menu, not a native <select>.
//
// A native <select> could not be driven by our browser automation, which cost
// this feature its verification cycle last time. Using the same .pbnew-menu
// pattern the row action menus already use keeps it drivable and matches Or's
// wording ("opens a menu containing exactly …").
//
// The parent handles the confirmation modal — this component only fires
// `onPick(rule)` when the administrator chooses one of the two options.
//
// PRD §A5 names exactly two manual actions, and their ORDER is part of the
// spec: "Suggestions included in earlier lists" is the primary one, "added
// before today" the secondary. `before_fill` is no longer offered here — it
// answers a question about our automation rather than about what the client has
// already seen, which is what an editor is actually deciding. The rule still
// exists server-side for its existing callers.
export default function ArchiveOldMenu({ onPick, size = 'md' }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  // §12 — this menu also sits low on the page in a narrow window.
  const { wrapRef: flipWrapRef, menuRef: flipMenuRef, style: flipStyle } = useFlipMenu(open);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  const pick = (rule) => { setOpen(false); onPick(rule); };

  return (
    <div
      className="pbnew-archive-old"
      ref={(el) => { wrapRef.current = el; flipWrapRef.current = el; }}
      style={{ position: 'relative' }}
    >
      <button
        type="button"
        className={size === 'sm' ? 'pbnew-btn' : 'pbnew-btn'}
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <ArchiveOutlinedIcon style={{ fontSize: 15 }} /> Archive old suggestions…
        <ExpandMoreOutlinedIcon style={{ fontSize: 16, marginLeft: 2 }} />
      </button>
      {open && (
        <div className="pbnew-menu" ref={flipMenuRef} style={{ right: 0, minWidth: 260, ...flipStyle }}>
          <button className="pbnew-menu-item" onClick={() => pick('in_earlier_list')}>
            Included in earlier lists
          </button>
          <button className="pbnew-menu-item" onClick={() => pick('before_today')}>
            Added before today
          </button>
        </div>
      )}
    </div>
  );
}
